export type ServiceScheduleItem = {
  id: string;
  duration: number;
};

export type WeeklyServiceHour = {
  service_id: string;
  day_of_week: number;
  start_time: string;
  end_time: string;
};

export const timeToMinutes = (value: string | null | undefined): number => {
  const [hours, minutes] = String(value || "00:00").split(":").map(Number);
  return (Number.isFinite(hours) ? hours : 0) * 60 + (Number.isFinite(minutes) ? minutes : 0);
};

export const minutesToTime = (value: number): string => {
  const bounded = Math.max(0, Math.min(24 * 60 - 1, value));
  return `${Math.floor(bounded / 60).toString().padStart(2, "0")}:${(bounded % 60).toString().padStart(2, "0")}`;
};

export const areServicesAvailableOnDay = (
  services: ServiceScheduleItem[],
  hours: WeeklyServiceHour[],
  dayOfWeek: number,
): boolean => services.every((service) => {
  const rows = hours.filter((hour) => hour.service_id === service.id);
  return rows.length === 0 || rows.some((hour) => hour.day_of_week === dayOfWeek);
});

export const doesSlotFitServiceHours = (
  slot: string,
  services: ServiceScheduleItem[],
  hours: WeeklyServiceHour[],
  dayOfWeek: number,
): boolean => {
  let segmentStart = timeToMinutes(slot);
  return services.every((service) => {
    const rows = hours.filter((hour) => hour.service_id === service.id);
    const allowed = rows.length === 0 || rows.some((hour) =>
      hour.day_of_week === dayOfWeek
      && segmentStart >= timeToMinutes(hour.start_time)
      && segmentStart + Math.max(1, service.duration) <= timeToMinutes(hour.end_time)
    );
    segmentStart += Math.max(1, service.duration);
    return allowed;
  });
};
